import instance from "../../axios/axios-user";
import { PostAnalysisProps } from "../../redux/slices/postAnalysis/PostAnalysis";
import { API_PATHS } from "../api_paths";

const getPostMetadata = (post_id: string) => {
  return instance.get(API_PATHS.posts.getPostMetadata + post_id);
};

const updateCheckPassed = ({
  post_id,
  check_passed,
}: PostAnalysisProps.updateCheckPassed) =>
  instance(API_PATHS.posts.getPostMetadata + post_id + "/check-passed", {
    method: "PUT",
    data: {
      check_passed,
    },
  });

export const METADATA_POSTS = {
  getPostMetadata,
  updateCheckPassed,
};
